import { TextField as TextFieldWrapper, styled } from '@mui/material';

export const CustomCssDateField = styled(TextFieldWrapper)({
  '&.MuiFormControl-root': {
    '& .MuiInputBase-root': {
      width: '131px',
      height: '36px',
    },
  },
  '& label.Mui-focused': {
    color: '#949494',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'green',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: '1px solid #D7DDE9',
    },
    '&:hover fieldset': {
      border: '1px solid #D7DDE9',
    },
    '&.Mui-focused fieldset': {
      border: '1px solid #D7DDE9',
    },
  },
});
